import Swiper, { Navigation, Pagination, Thumbs, Autoplay } from 'swiper'

import swiperConfigs from './swiper-configs'

Swiper.use([Navigation, Pagination, Thumbs, Autoplay])

const initSwiper = root => {
  let heroSwiper

  const swiperElementsThumbnailsFirst = [
    ...root.querySelectorAll(
      '[data-swiper]:not([data-thumbs-element-selector])'
    ),
    ...root.querySelectorAll('[data-swiper][data-thumbs-element-selector]'),
  ]

  swiperElementsThumbnailsFirst.forEach(el => {
    const config = {}
    const domRoot = el.closest('[data-swiper-dom-root]') || el

    const prevButton = domRoot.querySelector('.swiper-button-prev')
    const nextButton = domRoot.querySelector('.swiper-button-next')

    if (prevButton && nextButton) {
      config.navigation = {
        prevEl: prevButton,
        nextEl: nextButton,
      }
      prevButton.addEventListener('click', e => e.stopPropagation())
      nextButton.addEventListener('click', e => e.stopPropagation())
    }

    const pagination = domRoot.querySelector('.swiper-pagination')

    if (pagination) {
      config.pagination = {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      }
    }

    if ('thumbsElementSelector' in el.dataset) {
      const element = domRoot.querySelector(el.dataset.thumbsElementSelector)

      if (element) {
        config.thumbs = {
          swiper: element.swiper,
        }
      }
    }

    const extraConfig = swiperConfigs[el.dataset.swiper]

    if (extraConfig) {
      Object.assign(config, extraConfig)
    }

    const swiper = new Swiper(el, config)

    if ('autoplay' in config) {
      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            swiper.autoplay.stop()
          } else {
            swiper.autoplay.start()
          }
        },
        false
      )
    }

    if (el.dataset.swiper === 'hero') {
      heroSwiper = swiper
    }

    if (config.slidesPerView === 'auto') {
      el.querySelectorAll('img').forEach(img => img.addEventListener('load', () => {
        swiper.update()
        swiper.slideTo(0, 0)
      }))
    }
  })

  return {
    heroSwiper,
  }
}

export default initSwiper
